/** @jsx jsx */

import { jsx, render, Query, SelectionSet, Field, EnumScalar, Variable, ListScalar, IdScalar } from "graphql-jsx";
import { clients } from "utils/clients";
import { ValidTypeScalar } from "GraphQL/Scalars";
import { ValidType } from "constants/ValidType";

type Option = {
  genreList: readonly string[];
};

export const GetGenreIncludeChild = async ({ genreList }: Option) => {
  const $remove = <ValidTypeScalar value={ValidType.REMOVE} />;
  const $genreList = <Variable name="genre_list" scalar={<ListScalar scalar={<IdScalar isNullable={false} />} />} value={genreList} />;
  const { query, variables } = render(
    <Query operationName="GET_GENRE_INCLUDE_CHILD">
      <SelectionSet
        name="genre"
        alias="list"
        argument={{
          first: 999,
          group: true,
          orderBy: <EnumScalar type="GenreOrderByInput" value="genre_id__ASC" items={["genre_id__ASC"]} />,
          where: {
            type_kind: "genre",
            valid_check__not: $remove,
            OR: [
              {
                genre_id__in: $genreList
              },
              {
                genre_self_relation_child__some: {
                  genre_self_relation_parent__some: {
                    genre_id__in: $genreList
                  }
                }
              }
            ]
          }
        }}
      >
        <Field name="genre_id" alias="id" />
        <Field name="name" />
        <Field name="type_kind" alias="typeKind" />
      </SelectionSet>
    </Query>
  );
  type Data = {
    list: {
      readonly id: string;
      readonly name: string;
      readonly typeKind: string;
    }[];
  };
  const { data, errors } = await clients.genre.request<Data>(query, variables);
  if (!data || errors) {
    return [];
  }
  return data.list;
};
